"use client"
import Footer from "./Footer"
import Header from "./Header" 
import { useNavigate } from "react-router-dom"

const ProductInfoSection = ({ onCMIClick, onTipsClick }) => {
  const navigate = useNavigate()
  const handleCMIDownload = () => {
    const link = document.createElement("a")
    link.href = "https://mw.readyforyourreview.com/documents/CMI - Mediwhistle NEW.pdf"
    link.download = "CMI-Mediwhistle-ky9.pdf"
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    // onCMIClick(); // Commented out to prevent redirect, only download
  }

  const handleTipsClick = () => {
    // const link = document.createElement('a');
    // link.href = 'https://mw.readyforyourreview.com/documents/Budii-Patient-Tips-j5r.docx';
    // link.download = 'Budii-Patient-Tips-j5r.docx';
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
    onTipsClick(); // Call to show the Tips page
  }

  return (
    <>
      <Header onHomeClick={() => navigate("/")} onHealthcareClick={() => navigate("/contact")} />
      <section className="pt-36 py-24 bg-stone-50 h-[100%] lg:h-[100vh] flex justify-center items-center">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-emerald-800 mb-4">
              Product Information
            </h2>
            <p className="text-lg text-charcoal-600 max-w-2xl mx-auto">
              Access essential information and helpful resources for your Mediwhistle device
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {/* CMI Button */}
            <div className="bg-white p-10 rounded-2xl border border-stone-200 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
              <div className="text-center">
                <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <svg
                    className="w-10 h-10 text-emerald-700"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                </div>
                <h3 className="text-2xl font-semibold text-charcoal-800 mb-4">
                  Consumer Medicine Information
                </h3>
                <p className="text-charcoal-600 mb-8">
                  Access detailed product information, usage guidelines, and safety instructions
                </p>
                <button
                  onClick={handleCMIDownload}
                  className="w-full bg-emerald-800 hover:bg-emerald-700 text-white py-3 px-6 rounded-lg font-medium shadow-md transition-colors duration-200"
                >
                  Download CMI
                </button>
              </div>
            </div>

            {/* Tips & Tricks Button */}
            <div className="bg-white p-10 rounded-2xl border border-stone-200 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
              <div className="text-center">
                <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <svg
                    className="w-10 h-10 text-amber-700"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                    />
                  </svg>
                </div>
                <h3 className="text-2xl font-semibold text-charcoal-800 mb-4">
                  Tips & Tricks
                </h3>
                <p className="text-charcoal-600 mb-8">
                  Learn simple instructions and best practices for using your device effectively
                </p>
                <button
                  onClick={handleTipsClick}
                  className="w-full bg-amber-600 hover:bg-amber-700 text-white py-3 px-6 rounded-lg font-medium shadow-md transition-colors duration-200"
                >
                  View Tips & Tricks
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
       {/* <Footer
        onTermsClick={() => navigate("/terms")}
        onPrivacyClick={() => navigate("/privacy")}
      /> */}
    </>
  )
}

export default ProductInfoSection
